module.exports = __webpack_public_path__ + "media/app/assets/covenants/kyrian-f790480823bc2b3ad9f053544a722e98.png";